const $ = require('../sukoa-jquery.cjs');

function Element(list, $elem) {
    this.$domElt = $elem;
    this.uuid = $elem.attr("data-id");
    this.$tags = $elem.find(".tag");
    this.displayed = true;
    this.categories = [];
    this.list = list;
    this.left = 0;
    this.top = 0;
    this.originalPosition = {};
    this.leftMargin = 12;
    this.topMargin = 20;
    this.nextAction = "none";
}

Element.prototype.activate = function() {
    let self = this;
    this.$tags.each(function() {
        self.categories.push($(this).attr("data-filter"));
    });
    this.addViewParamToTagLink();
    if(typeof self.$domElt.attr("data-filter") !== typeof undefined && self.$domElt.attr("data-filter") !== "") {
        self.categories = self.$domElt.attr("data-filter").split(",");
    }
    this.calculatePosition();
    this.originalPosition = this.getCurrentPositionCss();
    return this;
};

Element.prototype.getCurrentPositionCss = function() {
    return {"top":this.top+"px", "left":this.left+"px"}
};

Element.prototype.addViewParamToTagLink = function() {
    let self = this;
    this.$tags.click(function(e){
        e.preventDefault();

        let url = $(this).attr("href") + "&view=" + self.list.currentDisplay;
        if(history.replaceState) {
            history.replaceState(null, null, url);
            self.list.applyUrlParameters();
            for(let e in self.list.elementsState) {
                let activeTag = self.list.elementsState[e].$domElt.find('.tag[data-filter="'+$(this).attr("data-filter")+'"]');
                if(activeTag.size()>0) {
                    activeTag.addClass("active");
                }
            }

        } else {
            window.location.href = url;
        }
    });
};

Element.prototype.showMe = function(css) {
    if(typeof css !== typeof undefined) {
        this.$domElt.css(css);
    }
    this.$domElt.fadeIn();
};

Element.prototype.hideMe = function() {
    this.$domElt.fadeOut();
};

Element.prototype.transfertMe = function(css) {
    this.$domElt.css(css);
};

Element.prototype.calculatePosition = function() {
    this.top = this.$domElt.offset().top - this.list.elementsWrapperTopOffset - this.topMargin;
    if(this.top < 0) {this.top = 0;}
    this.left = this.$domElt.offset().left - this.list.elementsWrapperLeftOffset - this.leftMargin;
    if(this.left<0){this.left = 0;}
    this.$domElt.css({
        "top" : this.top + "px",
        "left" : this.left + "px"
    });
};

Element.prototype.fixMyPosition = function() {
    //this.calculatePosition();
    this.$domElt.css({
        "position" : "absolute"
    });
};

Element.prototype.releaseMyPosition = function() {
    this.$domElt.css({
        "position" : "static"
    });
};

Element.prototype.filterme = function (filtersState) {
    //this.fixMyPosition();
    this.$tags.removeClass("active");
    let keepMeImCool = true;
    for(let f in filtersState) {
        keepMeImCool = keepMeImCool && filtersState[f].filterElement(this);
        if(!keepMeImCool){
            break;
        }
    }
    this.nextAction = "none";
    if(!this.displayed && keepMeImCool) {
        this.nextAction  = "showMe";
        //this.showMe();
    } else if(this.displayed && !keepMeImCool) {
        this.nextAction  = "hideMe";
        //this.hideMe();
    } else if(this.displayed && keepMeImCool) {
        this.nextAction  = "transfertMe";
        //this.transfertMe();
    }
    this.displayed = keepMeImCool;
    return this.displayed;
};

export default Element;
